<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>质保卡库存</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索名称/型号/卡号/手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          @click="doNew(1)"
          class="c-m-l-10"
          v-if="osg.has('WarrantyProductInventorys,add')"
        >
          新增
        </el-button>
        <el-button
          type="primary"
          v-if="osg.has('WarrantyProductInventorys,export')"
          class="c-m-l-10"
          @click="
            osg.doExport(
              Object.assign(
                {
                  'in:state|integer#and': 1,
                  'regex:warrantyProductName|string#or': searchValue,
                  'regex:warrantyProductCode|string#or': searchValue,
                  'regex:inventoryCode|string#or': searchValue,
                  'regex:uOrderId|string#or': searchValue,
                  'regex:customerPhone|string#or': searchValue,
                  notFilterBelongTo: '1',
                  sortField: 'createTime',
                  sortOrder: 'desc',
                  beanName: 'warrantyProductInventory',
                  title: '质保卡库存'
                },
                queryData
              ),
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="scope.row.status == 0 && osg.has('WarrantyProductInventorys,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status == 0 && osg.has('WarrantyProductInventorys,remove')"
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status == 0 && osg.has('WarrantyProductInventorys,submitAudit')"
                    @click.native="doAudit(scope.row, 1)"
                  >
                    提交审核
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.status == 1 && osg.has('WarrantyProductInventorys,withdrawAudit')
                    "
                    @click.native="doAudit(scope.row, 0)"
                  >
                    撤回审核
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.status == 1 &&
                        osg.has(
                          'WarrantyProductInventorys?ne%3Astatus%7Cinteger%23and=0,operatorAudit'
                        )
                    "
                    @click.native="doAudit(scope.row, 2)"
                  >
                    服务商确认
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.status == 2 &&
                        osg.has(
                          'WarrantyProductInventorys?ne%3Astatus%7Cinteger%23and=0,activationAudit'
                        )
                    "
                    @click.native="activation(scope.row)"
                  >
                    服务商开卡
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProductInventorys,able') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProductInventorys,able') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyProductInventorys,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档')"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      osg.has('WarrantyProductInventorys?state=archived,recover') &&
                        state == 'archived'
                    "
                    @click.native="doArchive(scope.row, '恢复')"
                  >
                    恢复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="质保卡库存信息"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :upload="upload"
        :fields="extFields"
        :options="options"
        ref="form"
        labelWidth="140px"
        @changeForm="osg.changeForm"
      >
        <template slot="partnerName">
          <el-select
            v-model="formData.partnerId"
            @change="handlePartnerSelect"
            @clear="
              querypartnerSearch();
              delete formData.partnerName;
              delete formData.partnerCode;
              delete formData.orgId;
              delete formData.partnerId;

              delete formData.warrantyProductName;
              delete formData.warrantyProductCode;
              delete formData.warrantyProductId;
            "
            placeholder="请选择伙伴"
            clearable
            filterable
            remote
            :remote-method="querypartnerSearch"
          >
            <el-option
              v-for="item in options.partners"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </template>
        <template slot="warrantyProductName">
          <el-select
            v-model="formData.warrantyProductId"
            @change="selectWarrantyProductChange"
            @clear="getWarrantyProducts(null)"
            clearable
            filterable
            placeholder="请选择质保卡产品"
          >
            <!-- remote -->
            <!-- :remote-method="getWarrantyProducts" -->
            <el-option
              v-for="item in options.warrantyProducts"
              :key="item._id"
              :label="item.label"
              :value="item._id"
            ></el-option>
          </el-select>
        </template>
        <!-- <template slot="warrantyProductProductList">
          <el-select
            v-model="formData.warrantyProductProductList"
            clearable
            placeholder="请选择质保卡产品"
          >
            <el-option
              v-for="item in options.productBizType.filter(item =>
                formData.warrantyProductProductList.includes(item.value)
              )"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->

        <!-- <template slot="productList">
          <el-select
            v-model="formData.productList"
            @change="$forceUpdate()"
            @clear="getProduct"
            clearable
            multiple
            remote
            :remote-method="getProduct"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
        <!-- <template slot="countryUse">
          <el-select v-model="formData.countryUse" clearable placeholder="请选择">
            <el-option
              v-for="item in options.isNational"
              :key="item.value"
              :label="item.label"
              :value="Boolean(item.value)"
            ></el-option>
          </el-select>
        </template> -->
        <!-- <template slot="orgIds">
          <el-cascader
            v-model="formData.orgIds"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            clearable
          ></el-cascader>
        </template> -->
      </c-form>
      <div
        v-if="
          Array.isArray(options.productBizType) &&
            Array.isArray(formData.exts.warrantyProductProductScopeList)
        "
      >
        <span>使用防水产品</span>
        <el-checkbox-group
          style="margin-top:10px"
          v-model="formData.exts.warrantyProductProductScopeList"
          @change="$forceUpdate()"
        >
          <el-checkbox
            v-for="item in options.productBizType.filter(item =>
              formData.exts.warrantyProductProductScopeList.includes(item.value)
            )"
            :label="item.value"
            :key="item.value"
            disabled
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="质保卡库存开卡"
      :visible.sync="openContactDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item
          label="客户名称"
          :rules="{
            required: true,
            message: '客户名称不能为空'
          }"
          prop="customerName"
        >
          <el-input v-model="formData.customerName"></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          :rules="{
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: '联系方式格式有误！',
            trigger: 'blur'
          }"
          prop="customerPhone"
        >
          <el-input v-model="formData.customerPhone"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="exts.certificateType">
          <el-select v-model="formData.exts.certificateType">
            <el-option
              v-for="item in options.certificateType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="exts.certificateNum">
          <el-input v-model="formData.exts.certificateNum"></el-input>
        </el-form-item>
        <el-form-item
          label="省市区"
          prop="exts.area"
          :rules="{
            required:
              !formData.exts.warrantyCardRequiredarea ||
              formData.exts.warrantyCardRequiredarea == '1',
            trigger: ['change', 'blur'],
            message: '省市区不能为空'
          }"
        >
          <template v-if="areaActivation.options && areaActivation.options.length">
            <el-cascader
              :options="areaActivation.options"
              :props="areaActivation.props"
              v-model="formData.exts.area"
              clearable
            ></el-cascader>
          </template>
          <template v-else>
            <el-cascader
              :options="area.options"
              :props="areaActivation.props"
              v-model="formData.exts.area"
              clearable
            ></el-cascader>
          </template>
        </el-form-item>
        <el-form-item
          label="详细地址"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '详细地址不能为空'
          }"
          prop="exts.address"
        >
          <el-input type="textarea" v-model="formData.exts.address"></el-input>
        </el-form-item>
        <el-form-item
          :rules="{
            required: true,
            trigger: 'blur',
            message: '使用防水产品不能为空'
          }"
          label="防水产品"
          prop="exts.warrantyProductProductList"
        >
          <el-select
            v-if="
              Array.isArray(options.productBizType) &&
                Array.isArray(formData.exts.warrantyProductProductScopeList)
            "
            v-model="formData.exts.warrantyProductProductList"
            clearable
            multiple
            placeholder="请选择使用防水产品"
          >
            <el-option
              v-for="item in options.productBizType.filter(item =>
                formData.exts.warrantyProductProductScopeList.includes(item.value)
              )"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约时间" prop="exts.applyTime">
          <el-date-picker
            v-model="formData.exts.applyTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="预约上门时间"
          ></el-date-picker>
        </el-form-item>
        <teamplete v-if="currentRoleData._id == '2721661854718313626'">
          <el-form-item label="直分监理" prop="exts.directSupervisionId">
            <el-select
              v-model="formData.exts.directSupervisionId"
              filterable
              remote
              :remote-method="getSRs"
              @change="directSupervisionChange"
              clearable
              placeholder="请选择直分监理"
            >
              <el-option
                v-for="item in options.directSupervisionIdList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </teamplete>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="activationBtn(formData, 3)">确 定</el-button>
        <el-button @click="openContactDetail = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'WarrantyProductInventorys',
  data() {
    return {
      name: 'warrantyProductInventory',
      fpi: {},
      searchValue: '',
      openDetail: false,
      openContactDetail: false, //客户信息弹窗
      formData: { exts: {}, productList: [] },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      options: {
        codecfg_productBizType: { codeId: 'productBizType' }
      },
      areaActivation: {
        props: {
          checkStrictly: false,
          expandTrigger: 'hover'
        },
        options: []
      },
      state: '', //已归档 archived
      refresh: true, //表格刷新
      user: {},
      area: {
        options: areajs.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      queryData: {}, //地址过滤参数
      currentRoleData: {} //当前登陆角色
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    // this.getOrgs();
    // debugger;
    this.user = JSON.parse(sessionStorage['loginAccount']);
    this.currentRoleData = JSON.parse(sessionStorage['currentRole']);
    this.osg.getFields('warrantyProductInventory', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.formData = { exts: {}, productList: [] };
      this.openDetail = false;
      this.openContactDetail = false;
      this.queryData = {}; //根据地址栏参数 添加到getData里
      for (let key in this.$route.query) {
        key = decodeURI(key);
        if (key.indexOf('|') != -1) {
          this.queryData[key] = this.$route.query[key];
        }
      }
      this.$util.renderExtField(this.extFields, this.formData);
      // this.getProduct();
      // this.getWarrantyProducts(); //质保卡产品
      this.querypartnerSearch();
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': 1,
        'regex:warrantyProductName|string#or': this.searchValue,
        'regex:warrantyProductCode|string#or': this.searchValue,
        'regex:inventoryCode|string#or': this.searchValue,
        'regex:uOrderId|string#or': this.searchValue,
        'regex:customerPhone|string#or': this.searchValue,
        notFilterBelongTo: '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      params = Object.assign(params, this.queryData);
      this.osg.ajax('basic/warrantyProductInventory/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.getWarrantyProducts(row.partnerId);
      this.querypartnerSearch(row.partnerId);
      this.formData = row;
      this.openDetail = true;
    },
    doRemove(row) {
      this.osg.confirm(`确定要删除${row.warrantyProductName}吗？`, () => {
        this.osg.ajax(`basic/warrantyProductInventory/remove/${row._id}.do`, null, () => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doSave() {
      if (this.osg.isRepeatClick('doSave', 5000)) {
        return;
      }
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        if (!Array.isArray(this.formData.exts.warrantyProductProductList)) {
          this.formData.exts.warrantyProductProductList = [];
        }
        this.osg.ajax(
          'basic/warrantyProductInventory/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    //审核
    doAudit(row, newState) {
      row = this.$util.deepCopy(row);
      if (newState == 2) {
        // 入库确认人员、时间
        row.confirmName = this.user.name;
        row.confirmId = this.user._id;
        row.confirmTime = this.$util.readableTime();
      } else if (newState == 3) {
        // 激活人员、时间
        row.activateName = this.user.name;
        row.activateId = this.user._id;

        this.currentRoleData = JSON.parse(sessionStorage['currentRole']);

        if (this.currentRoleData._id == '4585674895642246643') {
          row.exts.directSupervisionId = this.user._id;
          row.exts.directSupervisionName = this.user.name;
        }
        if (row.exts.directSupervisionId) row.exts['dispatchFlag'] = '1';
        row.activateTime = this.$util.readableTime();
      }
      this.osg.ajax(
        '/basic/warrantyProductInventory/audit.do',
        { data: JSON.stringify({ warrantyProductInventory: row, newState }) },
        () => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        }
      );
    },
    //产品
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '1',
        'ne:productType|string#and': ''
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    //质保卡产品
    getWarrantyProducts(partnerId) {
      if (!partnerId) {
        this.options.warrantyProducts = [];
        return;
      }
      let params = {
        page: 1,
        rows: 50,
        'in:partnerIds|string#or': partnerId,
        'is:countryUse|integer#or': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|integer#and': 1
        // notFilterOrgId: '1',
        // notFilterBelongTo: '1'
      };
      this.osg.ajax('basic/warrantyProduct/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.warrantyProducts = res.data;
        this.$forceUpdate();
      });
    },
    //选择质保卡产品
    selectWarrantyProductChange(wpId) {
      if (wpId) {
        let item = this.options.warrantyProducts.find(item => item._id == wpId);
        //预设字段
        this.$set(this.formData, 'warrantyProductName', item.name || '');
        this.$set(this.formData, 'warrantyProductCode', item.code || '');
        this.$set(this.formData, 'warrantyProductId', item._id || '');
        //扩展字段
        this.$set(this.formData.exts, 'nameCode', item.exts.nameCode || ''); //名称code
        this.$set(this.formData.exts, 'codelabel', item.exts.codelabel || ''); //编号中文
        this.$set(this.formData.exts, 'warrantyProductPrice', item.price || ''); //单价(元)
        this.$set(this.formData.exts, 'warrantyProductUnit', item.unit || ''); //单位
        this.$set(this.formData.exts, 'warrantyProductProductScopeList', item.productList || ''); //使用防水产品
        if (item.exts.area) {
          this.$set(this.formData.exts, 'warrantyProductScopeArea', item.exts.area || ''); //质保卡管理省市区
        }
      } else {
        //预设字段
        delete this.formData.warrantyProductName;
        delete this.formData.warrantyProductCode;
        delete this.formData.warrantyProductId;

        //扩展字段
        delete this.formData.exts.nameCode; //名称code
        delete this.formData.exts.codelabel; //编号中文
        delete this.formData.exts.warrantyProductPrice; //单价(元)
        delete this.formData.exts.warrantyProductUnit; //单位
        delete this.formData.exts.warrantyProductProductScopeList; //使用防水产品
        delete this.formData.exts.warrantyProductScopeArea; //质保卡管理省市区
      }
    },
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'in:_id|array#and': orgIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.orgName = '全部';
          this.options.orgs = [res.data];
          if (resolve) resolve();
        },
        {
          noload: true
        }
      );
    },
    //查询伙伴
    querypartnerSearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 50,
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|integer#and': 1,
        'regex:name|string#or': queryString,
        'is:_id|string#or': queryString
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          this.options.partners = res.data;
          this.$forceUpdate();
          if (cb) cb(res.data);
        },
        { noload: true }
      );
    },
    //选择伙伴
    handlePartnerSelect(pId = '') {
      if (pId) {
        let item = this.options.partners.find(item => item._id == pId);
        this.$set(this.formData, 'partnerName', item.name || '');
        this.$set(this.formData, 'partnerCode', item.partnerNumber || '');
        this.$set(this.formData, 'orgId', item.orgId || '');
        this.$set(this.formData, 'part', item._id || '');

        this.getWarrantyProducts(pId);
        delete this.formData.warrantyProductName;
        delete this.formData.warrantyProductCode;
        delete this.formData.warrantyProductId;
      }
    },
    //激活
    activation(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.getSRs(); //查询直分监理的服务资源
      //根据orgId查询对应的服务资源的服务区域，赋值到省市区
      this.getServiceTerritory(row.orgId, arr => {
        let scopeSTArea = this.$util.deepCopy(arr).flat();
        //校验服务区域
        let scopeArea = [...new Set(scopeSTArea)];
        this.areaActivation.options = this.checkServiceArea(scopeArea, this.area.options); //赋值到省市区
        this.formData = this.$util.deepCopy(row || { exts: {} });
        this.osg.ajax(
          'basic/partner/query.do',
          {
            'is:_id|string#and': this.formData.partnerId,
            notFilterBelongTo: '1'
          },
          res => {
            if (res.data.length) {
              this.formData.exts.warrantyCardRequiredarea =
                res.data[0].exts.warrantyCardRequiredarea;
            } else {
              delete this.formData.exts.warrantyCardRequiredarea;
            }

            this.openContactDetail = true;
          },
          { noload: true }
        );
      });
    },
    //获取直分监理的服务资源列表
    getSRs(searchValue) {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc',
          'regex:name|string#and': searchValue,
          'is:state|integer#and': 1,
          'in:resourceType|array#and': 'technician'
        },
        res => {
          if (Array.isArray(res.data)) {
            this.$set(
              this.options,
              'directSupervisionIdList',
              res.data.map(item => {
                return { name: item.name, label: item.name, value: item.relatedRecordId };
              })
            );
            this.$forceUpdate();
          } else {
            this.$set(this.options, 'directSupervisionIdList', []);
          }
        }
      );
    },
    //修改直分监理
    directSupervisionChange(id) {
      let directSupervisionName = this.options.directSupervisionIdList.find(
        item => item.value == id
      ).name;
      // directSupervisionName = directSupervisionName.substr(0, directSupervisionName.indexOf('-')); //取服务资源-前面的名称
      this.formData.exts.directSupervisionName = directSupervisionName;
    },
    //校验服务区域
    checkServiceArea(scopeArr, areaOptions) {
      return areaOptions
        .map(pItem => {
          if (scopeArr.includes(String(pItem.value))) {
            pItem.children = pItem.children
              .map(cItem => {
                if (scopeArr.includes(String(cItem.value))) {
                  cItem.children = cItem.children
                    .map(dItem => {
                      if (scopeArr.includes(String(dItem.value))) {
                        return dItem;
                      } else {
                        return false;
                      }
                    })
                    .filter(dItem => dItem);
                  return cItem;
                } else {
                  return false;
                }
              })
              .filter(cItem => cItem);
            return pItem;
          } else {
            return false;
          }
        })
        .filter(item => item);
    },
    //获取服务区域
    getServiceTerritory(orgId, cb) {
      if (!orgId) return;
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          page: 1,
          rows: 100,
          'is:serviceCrewId|string#and': orgId,
          notFilterBelongTo: '1'
        },
        res => {
          if (true || (res.data[0] && res.data[0]._id)) {
            this.osg.ajax(
              'basic/serviceTerritory/query.do',
              {
                page: 1,
                rows: 50,
                notFilterOrgId: '1',
                'is:relatedIds|string#and': res.data[0]._id,
                notFilterBelongTo: '1'
              },
              resData => {
                let data = resData.data.map(item => {
                  return this.osg.isJson(item.area) ? JSON.parse(item.area) : [];
                });
                if (cb) cb(data.flat());
              }
            );
          } else {
            this.osg.toast('暂无服务区域！', 'warning');
          }
        }
      );
    },
    activationBtn(row, newState) {
      if (this.osg.validate()) {
        row.exts.area = row.exts.area || [];
        if (row.exts.area.length > 0) {
          row.exts.province = row.exts.area[0] || '';
          if (row.exts.area.length > 1) {
            row.exts.city = row.exts.area[1] || '';
            if (row.exts.area.length > 2) {
              row.exts.district = row.exts.area[2] || '';
              if (row.exts.area.length > 3) {
                row.exts.subdistrict = row.exts.area[3] || '';
              }
            }
          }
        }
        this.currentRoleData = JSON.parse(sessionStorage['currentRole']);
        this.doAudit(row, newState);
      }
    }
    // doEnable(id) {
    //   this.osg.ajax('basic/warrantyProductInventory/enable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doDisable(id) {
    //   this.osg.ajax('basic/warrantyProductInventory/disable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doArchive(row, msg) {
    //   this.osg.confirm(`是否确认${msg}WarrantyProductInventory ${row.name}？`, () => {
    //     this.osg.ajax('basic/warrantyProductInventory/archive/' + row._id + '.do', null, () => {
    //       this.getData();
    //       this.osg.toast(`已${msg}客户 ${row.name}`);
    //     });
    //   });
    // }
  },
  watch: {
    $route() {
      // window.$this = this;
      // this.doInit();
      // this.user = JSON.parse(sessionStorage['loginAccount']);
      // this.osg.getFields('warrantyProductInventory', () => {
      //   this.osg.getFpi();
      //   this.getData();
      // });
    }
  }
};
</script>
